import { Tag } from "antd";
import * as React from "react";

import * as styles from "./ClosableTag.module.less";

type ClosableTagItem = {
  key: string;
  label: React.ReactNode;
  onClose: () => void;
  onClick?: () => void;
};

type PropsClosableTagsList = {
  filterLabel?: React.ReactNode;
  tags: ClosableTagItem[];
  action?: React.ReactNode;
};

export const ClosableTagsList: React.FC<PropsClosableTagsList> = ({
  filterLabel = "Фильтры:",
  tags,
  action,
}) => (
  <div className={styles.filtersBox}>
    <span className={styles.filtersLabel}>{filterLabel}</span>
    <div className={styles.tagsViewport}>
      {tags.map((tag) => (
        <Tag
          key={tag.key}
          closable
          color="volcano"
          onClose={tag.onClose}
          onClick={tag.onClick}
          className={styles.tagItem}
        >
          <span className={styles.tagLabel}>{tag.label}</span>
        </Tag>
      ))}
    </div>
    {action ? <div className={styles.actionBox}>{action}</div> : null}
  </div>
);
